module.exports = "<div class=\"abstract-wrapper\">\n  <div class=\"layout-wrapper\">\n      <router-outlet></router-outlet>\n  </div>\n</div>​\n"